import { render, staticRenderFns } from "./DetailField.vue?vue&type=template&id=3d7e7ac1&scoped=true&"
import script from "./DetailField.vue?vue&type=script&lang=js&"
export * from "./DetailField.vue?vue&type=script&lang=js&"
import style0 from "./DetailField.vue?vue&type=style&index=0&id=3d7e7ac1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7e7ac1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d7e7ac1')) {
      api.createRecord('3d7e7ac1', component.options)
    } else {
      api.reload('3d7e7ac1', component.options)
    }
    module.hot.accept("./DetailField.vue?vue&type=template&id=3d7e7ac1&scoped=true&", function () {
      api.rerender('3d7e7ac1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/components/DetailField.vue"
export default component.exports